<div [attr.data-testid]="'icon-container'">
  <span
    [attr.data-testid]="'icon-image'"
    [style.width.em]="width"
    [style.background-image]="'url(' + (data.url | imageType) + ')'"
  >
  </span>
</div>
